import { createForm } from '../../../factories'

export default createForm(['name'])



// WEBPACK FOOTER //
// ./src/store/modules/client/forms/accessRequest.js